/* eslint-disable no-unused-vars */

import { numberToHexadecimal } from 'wallet/utils'

export enum SupportedChains {
  ethereum = 'ethereum',
  polygon = 'polygon',
  binance = 'binance',
}

export enum SupportedChainId {
  MAINNET = 1,
  RINKEBY = 4,
  POLYGON = 137,
  POLYGON_MUMBAI = 80001,
  BSC_MAINNET = 56,
  BSC_TESTNET = 97,
}

export interface AddEthereumChainParameter {
  chainId: string // A 0x-prefixed hexadecimal string
  chainName: string
  nativeCurrency: {
    name: string
    symbol: string // 2-6 characters long
    decimals: number
  }
  rpcUrls: string[]
  blockExplorerUrls?: string[]
  iconUrls?: string[] // Currently ignored.
}

export const getSampleChain = (
  chainID: SupportedChainId | number | string
): AddEthereumChainParameter | undefined => {
  if (Number(chainID) === SupportedChainId.BSC_MAINNET) {
    return {
      chainId: numberToHexadecimal(56),
      chainName: 'Smart Chain',
      nativeCurrency: {
        name: 'Smart Chain',
        symbol: 'BNB',
        decimals: 18,
      },
      rpcUrls: ['https://bsc-dataseed.binance.org/'],
      blockExplorerUrls: ['https://bscscan.com'],
    }
  }

  if (Number(chainID) === SupportedChainId.BSC_TESTNET) {
    return {
      chainId: numberToHexadecimal(97),
      chainName: 'Smart Chain - Testnet',
      nativeCurrency: {
        name: 'Smart Chain',
        symbol: 'BNB',
        decimals: 18,
      },
      rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
      blockExplorerUrls: ['https://testnet.bscscan.com'],
    }
  }

  return undefined
}
